export const iconFontAwesomeDisasterCrisisHouseCrack = (
	<i className="fa-solid fa-house-crack"></i>
);
